import Axios from "axios";
import { PresencePayload } from 'model/api';

export const notifyPresence = async (payload: PresencePayload): Promise<any> => {
  const response = await Axios.post('/presence', payload);
  return response.data;
}
